import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Quality",
  "lead": "在全球范围内，大多数教师都接受过培训，但在撒哈拉以南非洲地区，受过培训的教师比例从 2000 年的 85％ 逐渐下降到 2022 年的 64％。"
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, HighlightByIndex, IndicatorReference, QualityFramework, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky, Tooltip} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!QualityFramework) _missingMdxReference("QualityFramework", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  if (!Tooltip) _missingMdxReference("Tooltip", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_QUALITY"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "优质教育不能等同于或仅仅归结为学习成果。许多儿童无法享受到经过充分培训的教师、良好的学校基础设施或安全、无暴力的学习环境。"
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "优质教育难以监测，因为每个国家对教育的理解和定义各不相同。除了学习成果，全球教育目标 SDG 4 中衡量质量的指标并不多。"
    }), "\n", _jsx(_components.h2, {
      id: "教师",
      children: "教师"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.c.2",
      children: [_jsx(_components.p, {
        children: "教师是教育质量的基石。但是，在 2000 年之后，在推动初等教育普及的过程中，更多的学生走进了课堂，教师的招聘却未跟上步伐。结果，教室人满为患，教育质量也因此受到影响。"
      }), _jsx(QualityFramework, {
        highlighted: "教师",
        description: "了解有关教育质量框架的更多信息"
      }), _jsx(_components.p, {
        children: "下图显示了学校中学生与教师的比例。在一些撒哈拉以南非洲国家，尽管该比例自 2000 年以来有所改善，但师生比仍然比 20 世纪 80 年代的水平更糟。"
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "PTR"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["在", _jsx(HighlightByIndex, {
              index: "0",
              children: "撒哈拉以南非洲地区"
            }), "，继 1990 年至 2000 年间推动小学免费教育之后，儿童入学的速度超过了各国招募新教师的速度。因此，学生与教师的比例往往会显著增加。"]
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["与此同时，在", _jsx(HighlightByIndex, {
              index: "6",
              children: "在欧洲和北美"
            }), "，该比例自 2005 年以来一直保持在每位教师约 14 名学生。"]
          })
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "教学是一项艰巨的任务，没有做好充分准备的教师进入课堂会存在明显的不足。各国主要通过两种方式来衡量教师的准备情况。对教师的评估包括："
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["首先，他们是否具备", _jsx(_components.strong, {
          children: "资质"
        }), "，这表示他们是否具有国家标准规定的预期学历。\n-其次，他们是否接受过", _jsx(_components.strong, {
          children: "培训"
        }), "，无论其资质如何，都会评估他们是否接受过适当的教师培训。"]
      }), "\n"]
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.c.1",
      children: [_jsxs(_components.p, {
        children: ["受过培训意味着教师已经接受了", _jsx(Tooltip, {
          title: "教学知识",
          content: "有关教学途径、方法和技巧的知识。",
          children: "教学知识"
        }), "和", _jsx(Tooltip, {
          title: "专业知识",
          content: "例如，有关规范教学职业的法律框架的知识。",
          children: "专业知识"
        }), "培训。一些培训项目可能还涵盖", _jsx(Tooltip, {
          title: "内容知识",
          content: "关于课程、学科内容以及相关材料使用的知识。",
          children: "内容知识"
        }), "的培训。但是各国所需的培训类型各不相同，且相关信息匮乏。由于这些差异，尽管其是优质教育的关键要素之一，但受过培训的教师这一指标 [4.c.1] 是 SDG 4 监测框架中可比性最低的指标之一。"]
      }), _jsxs(_components.p, {
        children: ["在全球范围内，大多数教师都具备资质、经过培训，或两者兼而有之。例如，在", _jsx(HighlightByIndex, {
          index: "3",
          children: "拉丁美洲和加勒比地区"
        }), "，80％ 的教师都接受过培训。"]
      }), _jsxs(_components.p, {
        children: ["相比之下，在", _jsx(HighlightByIndex, {
          index: "0",
          children: "撒哈拉以南非洲地区"
        }), "，受过培训的教师比例从 2000 年的 85％ 下降到 2022 年的 64％。"]
      }), _jsx(Figure, {
        id: "TRAINED"
      }), _jsx(_components.p, {
        children: "对于缺乏具备资质且经训练的教师的国家来说，解决这一问题并非易事。鉴于高校毕业生总体人数较少，许多国家没有足够的合格教师来满足需求。这表明了教育体系的内部问题之间的相互关联性：一个层面的问题，例如中学教育完成率低，很容易在其他方面引发连锁反应，例如对于后续学生来说，缺乏受过培训的教师。"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "基础设施",
      children: "基础设施"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.a.1e",
      children: [_jsxs(_components.p, {
        children: ["一个适宜的学习环境必须配备足够的", _jsx(_components.strong, {
          children: "水"
        }), "和卫生设施，对女孩来说尤其如此。然而，在撒哈拉以南非洲地区，只有 53％ 的小学能提供基本用水，在东亚和东南亚为 77％，在中亚和南亚为 86％。"]
      }), _jsx(QualityFramework, {
        highlighted: "材料",
        description: "了解有关教育质量框架的更多信息"
      })]
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.a.1f",
      children: [_jsxs(_components.p, {
        children: ["特别是，缺乏隐私的", _jsx(_components.strong, {
          children: "卫生"
        }), "设施可能会被认为是不安全的，而无法满足经期卫生需求的设施可能会成为女孩上学的阻碍。因此，提供男女分开的卫生设施是一项关键的政策举措，可防止小学入学普遍延迟和女性随时间推移而辍学的问题。"]
      }), _jsx(_components.p, {
        children: "下图显示，不仅在撒哈拉以南非洲国家，而且在阿富汗、老挝人民民主共和国和尼泊尔等亚洲国家的小学中，仅有不到一半的学校拥有男女分开的卫生设施。在印度尼西亚，只有 43％ 的小学、56％ 的初中和 65％ 的高中配备了男女分开的卫生设施。"
      }), _jsx(Figure, {
        id: "SANITATION"
      })]
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.a.1a",
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "电力"
        }), "是优质学习环境的基本需求，但许多国家却缺乏电力供应。在低收入国家，73％ 的小学和 58％ 的高中没有电力供应。"]
      }), _jsx(_components.p, {
        children: "如下图所示，在尼加拉瓜和巴基斯坦，通电的小学只有不到一半。在一些撒哈拉以南非洲国家，学校通电的情况极为罕见：马达加斯加有 12％ 的学校通电，乍得只有 4％ 的学校通电。没有电，光线可能会不足，教师无法使用计算机进行管理或培训工作。缺电意味着无法通风、制冷或供暖，这可能会使教室变得不适合教学和学习。"
      })]
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.a.1b",
      children: [_jsxs(_components.p, {
        children: ["缺电也意味着无法使用技术和", _jsx(_components.strong, {
          children: "互联网"
        }), "。但是，电力并非阻碍互联网普及的唯一因素。在中等收入国家，37％ 的小学和 22％ 的高中有电力供应但没有互联网。即使学校接入了电源，电涌和停电也常发生。互联网的接入取决于国家电信基础设施、地理位置和学校支付服务费用的能力。"]
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "ELECTRIC"
          })
        }), _jsx(ScrollySection, {
          id: "LKA",
          children: _jsxs(_components.p, {
            children: ["在", _jsx(_components.strong, {
              children: "斯里兰卡"
            }), "，虽然所有小学都通电，但只有 41％ 的小学可以上网。土库曼斯坦有 34％ 的学校和约旦有 32％ 的学校也面临同样的情况。"]
          })
        }), _jsx(ScrollySection, {
          id: "ECU,URY",
          children: _jsxs(_components.p, {
            children: ["许多拉丁美洲国家的学校没有通电，也没有互联网。在", _jsx(_components.strong, {
              children: "厄瓜多尔"
            }), "，大约有 43% 的学校同时有电和网络，而在阿根廷，这一比例为 63%。", _jsx(_components.strong, {
              children: "乌拉圭"
            }), "是一个例外，该国 100％的小学同时有电和网络。"]
          })
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "暴力",
      children: "暴力"
    }), "\n", _jsx(_components.p, {
      children: "与学校相关的暴力行为或威胁可以是心理、身体或性的，可能发生在学校场所，也可能发生在上学的路上、家中或网络空间中。这些暴力行为往往源于不平等的权力关系，并且通常是负面的性别规范和陈规定型观念导致的结果。"
    }), "\n", _jsx(_components.p, {
      children: "尽管人们的注意力通常集中在枪击事件等极端事件上，但对儿童和青少年的教育产生最大负面影响的是更为常见且经常被忽视的暴力形式，例如欺凌。有关这些问题的数据仍然不足，因为收集数据时提出的问题涉及暴力行为的不同定义、不同的报告时限、不可比较的回答选项、隐私安排或道德协议。除此之外，对于涉及禁忌的暴力形式，如恐同欺凌，也存在瞒报的情况。"
    }), "\n", _jsx(QualityFramework, {
      highlighted: "school",
      description: "Learn more about the framework for education quality"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.a.2",
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "欺凌"
        }), "是记录最为广泛的校园暴力形式。它可能包括身体暴力、口头虐待以及意图通过羞辱或排斥来造成心理伤害。下图显示，在大多数国家，至少有三分之一的青少年是欺凌的受害者，且通常是男孩多于女孩。"]
      }), _jsx(Figure, {
        id: "BULLY_FIGHT"
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "身体暴力"
      }), "包括在校园内参与身体打斗、携带枪支、刀具或棍棒等武器或受到此类武器威胁、成为帮派成员或同伙或遭受教职工的身体暴力。"]
    }), "\n", _jsx(_components.p, {
      children: "2022 年，在 24 个国家的 15 岁男孩中，至少有 10％ 报告称曾参与过 3 次或以上的身体打斗，而在亚美尼亚，这一比例超过了 30％。"
    }), "\n", _jsx(_components.h2, {
      id: "结语",
      children: "结语"
    }), "\n", _jsx(_components.p, {
      children: "与此同时，全球范围内关于教师指标的可比数据却出人意料地匮乏。只有少数国家报告了教师的基本人数，而这些数据并未考虑教学时间、担任行政职务的教师和其他复杂情况。需要为受过培训的教师制定一套标准类型，这样我们才能正确地认识差距，并将这个问题提升到全球层面。"
    }), "\n", _jsx(_components.p, {
      children: "正如本文所示，在许多国家，提供“关注儿童、残疾和性别敏感”的教育设施以及“为所有人提供安全、非暴力、包容和有效的学习环境”仍是一项挑战。同时，衡量该问题的进展也很困难，因为相关的全球指标不是一项单一的衡量标准，而是一组涵盖多个维度的衡量标准。"
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.oecd-ilibrary.org/education/education-at-a-glance_19991487",
            children: "教育概览 — 经合组织 (OECD)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://theirworld.org/news/safe-schools-report-reveals-crises-challenges-action-needed-to-educate-children",
            children: "安全学校报告 — Their World"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://unesdoc.unesco.org/ark:/48223/pf0000232107",
            children: "与学校有关的性别暴力阻碍了全民优质教育的实现"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
